import { render, staticRenderFns } from "./PageBus.vue?vue&type=template&id=21a9d18c&scoped=true&"
import script from "./PageBus.vue?vue&type=script&lang=js&"
export * from "./PageBus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a9d18c",
  null
  
)

export default component.exports